angular.module('zc.projects')

.directive 'campaignChisqTest', (CampaignStats) ->
  restrict: 'E'
  scope:
    project: '='
    campaign: '='
    filters: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_chisq_test.html'

  link: (scope, element, attrs) ->
    scope.chisq_test = true
    updateData = ->
      CampaignStats.aggregate
        dimension: 'daily'
        campaign_id: scope.campaign.id
        apikey: scope.campaign.apikey
        start_at: scope.filters.start_at
        end_at: scope.filters.end_at
      .then (campaign_stats) ->
        stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id]
        scope.chisq_test = CampaignStats.chisqTest stats
    scope.$watch 'filters', updateData, true



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_chisq_test.coffee